import React from 'react'
import { BiExpand } from 'react-icons/bi';

export const FullscreenButton = ({ onClick, color }) => {
    const colorClass = color ?? "white";
    
    return (
        <button onClick={onClick}>
            <span className={`w-full h-full text-${colorClass} text-3xl flex justify-center content-center items-center`}>
                <BiExpand />
            </span>
        </button>
    )
}
